// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"330455fa319c48faf851","303":"8e18692bd36c30bac18c","495":"4da2e5f0beb69a050d11"}[chunkId] + ".js";
};